import AsyncDownloadSharedProjectAssetsPresenterFactory from 'src/factories/AsyncDownloadSharedProjectAssetsPresenterFactory';
import AsyncDownloadAssetsPresenterFactory from 'src/factories/AsyncDownloadAssetsPresenterFactory';

export const downloadAssetsPresenterFactoryFor = ( shareRef?: string ) => (
	shareRef ? new AsyncDownloadSharedProjectAssetsPresenterFactory( {
		shareRef
	} ) : new AsyncDownloadAssetsPresenterFactory()
);
